module.exports = __webpack_public_path__ + "img/bague-de-centrage.a0fe1b25.jpg";